// extracted by mini-css-extract-plugin
export var anchor = "_55-0";
export var discard = "_55-4";
export var muiTooltipTooltip = "_55-6";
export var notificationBar = "_55-3";
export var saveButtonHoverSlotWrapper = "_55-5";
export var show = "_55-2";
export var spacer = "_55-1";